const VERSION = '2.6.7';
export function getVersionString() {
    return VERSION;
}
